import React, { useEffect, useState } from "react"
import { useSiteLocation } from "../../hooks"
import QuoteSection from "../quote-section"

const selector = {
  requestCallBackBtn: ".request-callback-btn",
}

const EmbedRequestCallBackModal = ({ location }) => {
  const siteLocation = useSiteLocation(location)
  const [isVisible, setIsVisible] = useState(false)

  const onClickOpenRequestCallBackModal = () => {
    const requestCallBackBtn = document.querySelector(
      selector.requestCallBackBtn
    )

    if (!requestCallBackBtn) return

    requestCallBackBtn.onclick = () => {
      setIsVisible(true)
    }
  }

  const onListenMessageIframe = e => {
    const { value = true } = e.data
    if (
      e.data.message === "RequestCallBackModalStatus" ||
      e.data.message === "CloseSuccessModalStatus"
    ) {
      setIsVisible(value)
    }
  }

  useEffect(() => {
    const bodyRef = document.querySelector("body")

    isVisible
      ? (bodyRef.style.position = "fixed")
      : bodyRef.style.removeProperty("position")
  }, [isVisible])

  useEffect(() => {
    onClickOpenRequestCallBackModal()
    window.addEventListener("message", onListenMessageIframe)
    return () => window.removeEventListener("message", onListenMessageIframe)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isVisible && (
      <QuoteSection
        src={`${process.env.GATSBY_BACKSTAGE_URL}/${siteLocation}/request-callback`}
        className="fixed top-0 left-0 w-full z-20 h-screen"
        title="request-callback"
      />
    )
  )
}

export default EmbedRequestCallBackModal
